export * from "./document-actions/ExportDocumentAction";
export * from "./DocumentActionsMenu";
export interface ArticleAction {
  (props: any): React.ReactNode;
}
